export type AuthenticationSocialProvider =
    | 'other'
    | 'amazon'
    | 'apple'
    | 'facebook'
    | 'google'
    | 'linkedin'
    | 'microsoft'
    | 'twitter'
    | 'github'
    | 'yahoo';

export type AuthenticationType = 'other' | 'local' | 'social';

export type AuthenticationMode = 'other' | 'biometric' | 'mail' | 'mfa' | 'otp' | 'password';

export interface Authentication {
    socialProvider?: AuthenticationSocialProvider;
    type?: AuthenticationType;
    mode?: AuthenticationMode;
}
